import type { GetMeUserResponse } from "@nlc/shared-types";

import { USER_ROLES } from "@nlc/shared-types";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { AiCostsPage, aiCostsSearchZod } from "@/features/ai-costs";

export const Route = createFileRoute("/_auth/_app-shell/admin/ai-costs")({
  beforeLoad: async ({ context }) => {
    const userData = context.queryClient.getQueryData<GetMeUserResponse>([
      "user",
    ]);

    if (userData?.user?.roleName !== USER_ROLES.SUPER_ADMIN) {
      throw redirect({ to: "/requests" as string });
    }
  },
  component: AiCostsPage,
  validateSearch: aiCostsSearchZod,
});
